import React from 'react';
import type { CommandServices } from '@wix/cli-command-contract';
import { NO_TTY_JSON_OUTPUT_OPTION } from '@wix/cli-command-contract';
import { createCommand, Option } from '@commander-js/extra-typings';
import { createI18nT } from '../i18n.js';
import { validateBase, validateSite } from './validations.js';

export const previewCommand = (services: CommandServices) => {
  const t = createI18nT();

  return createCommand('preview')
    .option(
      '-s, --site <site-id>',
      t('app_preview_command_def.option.site'),
      validateSite
    )
    .option(
      '--base-url <url>',
      t('app_preview_command_def.option.base_url'),
      validateBase
    )
    .addOption(
      new Option(
        NO_TTY_JSON_OUTPUT_OPTION,
        t('app_preview_command_def.option.json')
      ).hideHelp()
    )
    .action(async (options, command) => {
      const { site, baseUrl, json } = options;

      const { renderCommand, runCommand } = await import('./render-command.js');

      if (json) {
        return runCommand(command, services, async (model) => {
          const { nonInteractivePreview } = await import(
            '../non-interactive/preview.js'
          );
          return nonInteractivePreview(services, model, {
            baseUrl,
            siteId: site,
          });
        });
      }

      const { PreviewCommand } = await import(
        '../components/PreviewCommand/index.js'
      );
      await renderCommand(
        command,
        services,
        <PreviewCommand baseUrl={baseUrl} siteIdOverride={site} />
      );
    });
};
